import styled from 'styled-components'
import {Colors, FontSize} from './Constants'

export const StyledTag = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.AccentDark};
  border-radius: 4px;
  padding: 2px 10px;
`

export const PrimaryTag = styled(StyledTag)`
  background: rgba(242, 248, 251, 0.7);
`
export const SecondaryTag = styled(StyledTag)`
  background: rgba(242, 242, 242, 1);
`
